export const GEOLOCK_PURCHASE_LOADING = 'GEOLOCK_PURCHASE_LOADING';
export const GEOLOCK_PURCHASE_SUCCESS = 'GEOLOCK_PURCHASE_SUCCESS';

// -----------------  ERROR -----------------
export const GEOLOCK_PURCHASE_ERROR = 'GEOLOCK_PURCHASE_ERROR';
